<template>
  <span>
    <button type="button" class="btn btn-primary btn-xs mr-1" @click="toggle"><i class="fas fa-search"></i>&nbsp;Show</button>

    <b-modal
        ref="modal-container"
        v-model="modalShow" size="lg" title="Wazdan freespins" hide-footer
    >
      <form ref="form" @submit.stop.prevent="() => {}">
        <div v-for="({id, label}) in inputs" :key="id">
        <b-form-group :label="label" :label-for="`${id}-input`" v-if="isVisible(id)">
          <b-form-input :id="`${id}-input`"
                        v-model="formValues[id]"
                        autocomplete="off"
                        disabled
          />
        </b-form-group>
        </div>
      </form>
    </b-modal>
  </span>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      formValues: this.getInitialValues(),
      modalShow: false,
      inputs: [
        {id: 'id', label: 'ID' },
        {id: 'state', label: 'State' },
        {id: 'addDate', label: 'Add Date' },
        {id: 'startDate', label: 'Start Date'},
        {id: 'endDate', label: 'End Date'},
        {id: 'type', label: 'Type'},
        {id: 'currency', label: 'Currency'},
        {id: 'count', label: 'Count'},
        {id: 'tableId', label: 'Table ID'},
        {id: 'playerId', label: 'Player ID'},
        {id: 'ratio', label: 'Ratio'},
        {id: 'stake', label: 'Stake'},
        {id: 'value', label: 'Value'},
      ],
    }
  },
  props: [
      'defaultValues',
  ],
  methods: {
    isVisible(id) {
      if (id === 'value') {
        return this.formValues.type === 'variable';
      }
      if (id === 'stake' || id === 'count') {
        return this.formValues.type === 'regular';
      }
      return true;
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    getInitialValues() {
      return {
        id: null,
        state: null,
        meta: null,
        addDate: null,
        startDate: null,
        endDate: null,
        type: null,
        currency: null,
        count: null,
        campaignId: null,
        txId: null,
        gameId: null,
        skinId: null,
        playerId: null,
        ratio: null,
        stake: null,
      };
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
